module.exports = __webpack_public_path__ + "frontStatic/img/packaging.6368e2d3.png";